<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <GenericFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('PaymentLinkRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchPaymentLink"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="PaymentLinkRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
          @row-click="handleClick"
        >
          <template slot="link" slot-scope="{ row }">
            <span>https://dev-checkout.blusalt.net/{{ row.reference }}</span>
          </template>

          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../components/utils/TableWrapper/TableWrapper.vue";
import GenericFilter from "../../../../../components/filters/GenericFilter.vue";

const plansHeadings = {
  link: "Link",
  name: "Name",
  createdAt: "Date Created",
};

export default {
  name: "PaymentLinks",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Payment Link Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(plansHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    GenericFilter,
  },
  methods: {
    refetch(filters) {
      this.handleRefetch(filters, this.fetchPaymentLink, "PaymentLinkRef");
    },
    handleClick({ row }) {
      this.$router.push(
        `/payment-link-details/${this.clientid}/${row.reference}`
      );
    },
    async fetchPaymentLink() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, id: this.clientid, size: 25 };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantPaymentLinks",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.total;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  props: ["clientid"],
  created() {
    this.fetchPaymentLink();
  },
  mounted() {
    this.columns = Object.keys(plansHeadings).map((keyVal) => keyVal);
  },
};
</script>
